export default "__VITE_ASSET__BVRePsI2__"